module.exports = __webpack_public_path__ + "img/banQ.720ad9f1.jpg";